module.exports = {
      id: "pdf-usage",
      viewBox: "0 0 21.946 21.946",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#pdf",
      toString: function () {
        return this.url;
      }
    }